/**
 * Query key factory.
 *
 * Keys are built here so invalidation can be expressed at the right
 * granularity: adding a name invalidates `watchlistKeys.all` and refreshes the
 * card without touching the popular-stocks list, which is not the member's.
 */
export const watchlistKeys = {
  all: ['watchlist'] as const,
  collection: () => [...watchlistKeys.all, 'collection'] as const,
  /**
   * The "Add to watchlist" picker's search. The settled term is part of the
   * key, so each one is its own entry and typing back to a term already asked
   * for is answered from the cache rather than the wire.
   */
  candidateSearch: (term: string) => [...watchlistKeys.all, 'candidateSearch', term] as const,
  popular: () => [...watchlistKeys.all, 'popular'] as const,
}
